var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 38V34H12V20C12 17.2333 12.8333 14.775 14.5 12.625C16.1667 10.475 18.3333 9.06667 21 8.4V7C21 6.16667 21.2917 5.45833 21.875 4.875C22.4583 4.29167 23.1667 4 24 4C24.8333 4 25.5417 4.29167 26.125 4.875C26.7083 5.45833 27 6.16667 27 7V8.4C29.6667 9.06667 31.8333 10.475 33.5 12.625C35.1667 14.775 36 17.2333 36 20V34H40V38H8ZM24 44C22.9 44 21.9583 43.6083 21.175 42.825C20.3917 42.0417 20 41.1 20 40H28C28 41.1 27.6083 42.0417 26.825 42.825C26.0417 43.6083 25.1 44 24 44ZM16 34H32V20C32 17.8 31.2167 15.9167 29.65 14.35C28.0833 12.7833 26.2 12 24 12C21.8 12 19.9167 12.7833 18.35 14.35C16.7833 15.9167 16 17.8 16 20V34Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotifications);
export default __webpack_public_path__ + "static/media/ic_notifications.eca3c0029b8a791931fd974b969205ed.svg";
export { ForwardRef as ReactComponent };